/* eslint-disable */
const KP5CONSTANTS = {
  MSP_LOGGED_IN_KEY: 'mspLoggedIn',
  USP_LOGGED_IN_KEY: 'uspLoggedIn',
  MANAGED_TENANT_KEY: 'managedTenantId',
  MANAGED_TENANT_NAME: 'managedTenantName',
  TARGET_PATH: 'targetPath',
  REGISTER_PRODUCTS: {
    DEFAULT: '',
    CAPTURE: 'capture',
    // Workspace is now Knox Platform for Enterprise. But internally we still sometimes
    // use "workspace". One place where we use "workspace" is the registration product
    // field because it has existing data using "workspace".
    WORKSPACE: 'workspace',
    PLATFORM_FOR_ENTERPRISE: 'kpe',
    CONFIGURATOR: 'kc',
    CLOUD_SERVICES: 'kcs',
    GUARD: 'kg',
    MOBILE_ENROLLMENT: 'kme',
    MANAGE: 'km',
    EFOTA_ONE: 'kfm',
    DEPLOYMENT_PROGRAM: 'kdp',
    MANAGED_SERVICE_PROVIDER: 'msp',
    EE_DEVICES: 'ee-devices',
    SUITE: 'ks',
    CARE_PLUS: 'kscp',
    DEVICE_ASSET_INTELLIGENCE: 'kai',
    DEVICE_ASSET_INTELLIGENCE_ALIAS: 'kdai'
  },
  LEGAL_REGIONS: {
    EU_REGION: 'eu',
    GLOBAL_REGION: 'global',
    KOREA_REGION: 'korea',
    USA_REGION: 'usa',
    BRAZIL_REGION: 'brazil',
    TURKEY_REGION: 'turkey'
  },
  AMS_REGIONS: {
    EU_REGION: 'EU',
    US_REGION: 'US'
  },
  REGEX: {
    PHONE_NUMBER: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/,
    WEBSITE_URL:
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i,
    WHITESPACE_ONLY: /^\s*\S[\s\S]*$/
  },
  KCS_STATUSES: {
    ACTIVE: 'Active',
    REJECTED: 'Rejected',
    BLOCKED: 'Blocked',
    PENDING: 'Pending',
    UNAVAILABLE: 'Not Available',
    INVITED_ADMIN: 'Invited',
    REQUESTED_ADMIN: 'Requested',
    JOIN: 'Join',
    AF_APPROVED: 'AF_Approved',
    KNOX_SUITE: 'Knox Suite',
    FAILED: 'Failed' // When fetching from external API failed
  },
  MSP_KDP_NOTICE_HIDDEN_COOKIE_NAME: 'msp_kdp_notice_hidden',
  MSP_KDP_NOTICE_HIDDEN_FOR_DAYS: 1,
  VALID_ACCOUNT_PAGES: {
    ACCOUNT_INFORMATION: 'account-information',
    IP_SETTINGS: 'identity-provider-settings',
    PRIVACY_SETTINGS: 'privacy-settings'
  }
}

/**
 * KP5-3527: Adding new Registration Reasons
 * Please sync any changes with `knox-portal-cms` , `kp5-api-tenants-users`
 */
KP5CONSTANTS.REGISTRATION_REASONS = {
  FREE_TRIAL: 'FREE_TRIAL',
  PAID_LICENSE: 'PAID_LICENSE',
  KS_BASE_PLAN: 'KS_BASE_PLAN',
  EE_DEVICES: 'KS_BASE_PLAN',
  SUB_ADMIN_REGISTRATION: 'SUB_ADMIN_REGISTRATION'
}

// NOTE: REGISTER_PRODUCTS_WITH_PATHS should only consist of the registration pathways.
// These have been consolidated from KP2 to KP5. Only the following exist now.
KP5CONSTANTS.REGISTER_PRODUCTS_WITH_PATHS = [
  KP5CONSTANTS.REGISTER_PRODUCTS.DEFAULT,
  KP5CONSTANTS.REGISTER_PRODUCTS.CAPTURE,
  KP5CONSTANTS.REGISTER_PRODUCTS.PLATFORM_FOR_ENTERPRISE,
  KP5CONSTANTS.REGISTER_PRODUCTS.DEPLOYMENT_PROGRAM,
  KP5CONSTANTS.REGISTER_PRODUCTS.GUARD,
  KP5CONSTANTS.REGISTER_PRODUCTS.CARE_PLUS,
  KP5CONSTANTS.REGISTER_PRODUCTS.MANAGED_SERVICE_PROVIDER,
  KP5CONSTANTS.REGISTER_PRODUCTS.CONFIGURATOR
]

KP5CONSTANTS.REGISTER_SUBADMIN_PRODUCTS_WITH_PATHS = [
  KP5CONSTANTS.REGISTER_PRODUCTS.DEFAULT,
  KP5CONSTANTS.REGISTER_PRODUCTS.CAPTURE,
  KP5CONSTANTS.REGISTER_PRODUCTS.SUITE,
  KP5CONSTANTS.REGISTER_PRODUCTS.PLATFORM_FOR_ENTERPRISE,
  KP5CONSTANTS.REGISTER_PRODUCTS.DEPLOYMENT_PROGRAM,
  KP5CONSTANTS.REGISTER_PRODUCTS.GUARD,
  KP5CONSTANTS.REGISTER_PRODUCTS.CARE_PLUS,
  KP5CONSTANTS.REGISTER_PRODUCTS.MANAGED_SERVICE_PROVIDER,
  KP5CONSTANTS.REGISTER_PRODUCTS.CONFIGURATOR,
  KP5CONSTANTS.REGISTER_PRODUCTS.MOBILE_ENROLLMENT,
  KP5CONSTANTS.REGISTER_PRODUCTS.MANAGE,
  KP5CONSTANTS.REGISTER_PRODUCTS.EFOTA_ONE,
  KP5CONSTANTS.REGISTER_PRODUCTS.DEVICE_ASSET_INTELLIGENCE,
  KP5CONSTANTS.REGISTER_PRODUCTS.DEVICE_ASSET_INTELLIGENCE_ALIAS
]

KP5CONSTANTS.REGISTER_PRODUCTS_WITH_HIDDEN_PATHS = {
  // Hidden paths for KP-only registered MSP/RP users (not yet migrated to KPP)
  HIDDEN: [
    KP5CONSTANTS.REGISTER_PRODUCTS.DEPLOYMENT_PROGRAM,
    KP5CONSTANTS.REGISTER_PRODUCTS.MANAGED_SERVICE_PROVIDER
  ],
  // See const hiddenProductParam in packages/kp5-ui-public/pages/register/[[...productParam]]/index.js
  OTHERS: [
    null, // /en/user/register's productParam is null
    ...KP5CONSTANTS.REGISTER_SUBADMIN_PRODUCTS_WITH_PATHS
  ]
}

KP5CONSTANTS.ACCOUNT_PAGES = [
  KP5CONSTANTS.VALID_ACCOUNT_PAGES.ACCOUNT_INFORMATION,
  KP5CONSTANTS.VALID_ACCOUNT_PAGES.IP_SETTINGS,
  KP5CONSTANTS.VALID_ACCOUNT_PAGES.PRIVACY_SETTINGS
]

// For sub admin
KP5CONSTANTS.SERVICES_WITH_LEGAL_AGREEMENTS = [
  KP5CONSTANTS.REGISTER_PRODUCTS.GUARD,
  KP5CONSTANTS.REGISTER_PRODUCTS.CARE_PLUS
]

/**
 * Mapping of the enum codes returned by AMS login type API to their corresponding idp type name
 * The values are obtained from AMS-BE source code
 * https://github.sec.samsung.net/RAM-knox-deployment-services/ams-be/blob/478bf20b884c2fb327502eba682f5429075c0b07/wsm-ams/wsm-ams-model/src/main/java/com/samsung/knoxwsm/ams/idp/LoginType.java#L8-L12
 */
KP5CONSTANTS.AMS_IDP_TYPE_CODE_TO_NAME = {
  67: 'SAMSUNG_ACCOUNT',
  367: 'B2B_SAMSUNG_ACCOUNT',
  52: 'AZURE_AD',
  642: 'SAMSUNG_CORP_AD',
  23: 'NO_IDP'
}

export default KP5CONSTANTS
